// ================================
// common
// ================================
import TheHeader from "@/common/components/organisms/TheHeader.vue";
import TheFooter from "@/common/components/organisms/TheFooter.vue";
import ErrorSession from "@/general/components/errors/ErrorSession.vue";
import ErrorAuth from "@/general/components/errors/ErrorAuth.vue";
import ErrorNotFound from "@/general/components/errors/error-404.vue";

// ================================
// cms
// ================================
import CmsHeaderSearch from "@/general/components/pages/CmsHeaderSearch.vue";

// ================================
// components
// ================================
import Loading from "@/general/components/Loading.vue";
import LoadingProcess from "@/general/components/LoadingProcess.vue";
import LoadingContent from "@/general/components/LoadingContent.vue";
import LoadingPage from "@/general/components/LoadingPage.vue";
import Carousel2 from "@/general/components/carousels/Carousel2.vue";
// ================================
// components commons
// ================================
import Button from "@/common/components/atoms/ButtonLink.vue";
import ButtonMain from "@/common/components/atoms/ButtonMain.vue";
import ButtonLink from "@/common/components/atoms/ButtonLink.vue";
import CommonHeading from "@/common/components/atoms/CommonHeading.vue";
import PageNavi from "@/common/components/atoms/PageNavi.vue";
import TheBreadcrumb from "@/common/components/organisms/TheBreadcrumb.vue";

import FirstLoginModal from "@/general/components/pages/FirstLogin.vue";

import Vue from "vue";

// ================================
// common
// ================================
Vue.component("TheHeader", TheHeader);
Vue.component("TheFooter", TheFooter);
Vue.component("ErrorSession", ErrorSession);
Vue.component("ErrorAuth", ErrorAuth);
Vue.component("ErrorNotFound", ErrorNotFound);

// ================================
// cms
// ================================
Vue.component("CmsHeaderSearch", CmsHeaderSearch);

// ================================
// components
// ================================
Vue.component("LoadingProcess", LoadingProcess);
Vue.component("Loading", Loading);
Vue.component("LoadingContent", LoadingContent);
Vue.component("LoadingPage", LoadingPage);
Vue.component("Carousel2", Carousel2);

// ================================
// components commons
// ================================
Vue.component("Button", Button);
Vue.component("ButtonMain", ButtonMain);
Vue.component("ButtonLink", ButtonLink);
Vue.component("PageNavi", PageNavi);
Vue.component("CommonHeading", CommonHeading);
Vue.component("TheBreadcrumb", TheBreadcrumb);

Vue.component("FirstLoginModal", FirstLoginModal);
